/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { TextField } from '@molecules';
import { Button } from '@atoms';

import Form from '../Form';

import { FORM_SINGLE_FIELD } from './constants';
import RichTextField from '@components/molecules/RichTextField';

const FAQForm = ({ onSubmit, buttons, initialValues: initData }) => {
  const [form] = Form.useForm(FORM_SINGLE_FIELD);
  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  return (
    <Form
      form={form}
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      layout="vertical"
      labelAlign="left"
      colon={false}
    >
      {buttons && <h2>Edit question</h2>}
      <TextField {...FORM_SINGLE_FIELD.QUESTION} />
      <RichTextField {...FORM_SINGLE_FIELD.RESPONSE} />
      {buttons ? (
        buttons({ onSubmit: form.submit })
      ) : (
        <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
          ADD QUESTION
        </Button>
      )}
    </Form>
  );
};

export default FAQForm;
